import { render, staticRenderFns } from "./AppRating.vue?vue&type=template&id=115ca236&scoped=true&"
import script from "./AppRating.vue?vue&type=script&lang=ts&"
export * from "./AppRating.vue?vue&type=script&lang=ts&"
import style0 from "./AppRating.vue?vue&type=style&index=0&id=115ca236&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "115ca236",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/brilliant/brilliant/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('115ca236', component.options)
    } else {
      api.reload('115ca236', component.options)
    }
    module.hot.accept("./AppRating.vue?vue&type=template&id=115ca236&scoped=true&", function () {
      api.rerender('115ca236', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/views/landing/AppRating.vue"
export default component.exports